<div class="atlas-step">
  <div class="atlas-step-top-b"></div>
  <div class="atlas-step-container" [style.max-width]="(numSteps*20)+'%'">
    <div class="atlas-step-lines">
      <ng-container *ngFor="let number of numbers; let last = last;">
        <div  *ngIf="!last" [style.width]="lineWidth+'%'" [style.left]="stepsPositions[number-1]+'%'"
              [ngClass]="{current:currentStep===number+1,done:currentStep>number+1,notdone:currentStep<number+1}">
          <div></div>
        </div>
      </ng-container>
    </div>
    <div class="atlas-step-steps">
      <div  *ngFor="let number of numbers" [ngClass]="{current:currentStep===number,done:currentStep>number,notdone:currentStep<number}"  [style.left]="stepsPositions[number-1]+'%'">
        <div (click)="navigateOnClickStep(number)">
          {{number}}
        </div>
      </div>
    </div>
  </div>
</div>
